/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:edd013b1-e17c-4ce9-81c8-adf358c75a6a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_RpuOwAQBL",
    "aws_user_pools_web_client_id": "2strt704pv940kbephkn4dj3b8",
    "oauth": {
        "domain": "myredfolderstaging03ad6a97-03ad6a97-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://staging.myredfolder.kyybaapps.com/verfication/",
        "redirectSignOut": "https://staging.myredfolder.kyybaapps.com/logout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
